export default __webpack_public_path__ + "static/cinemaThoughtBuying-e847f7ceafb3683265426735a59be2d1.svg";